import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import React, { useState, useEffect } from 'react';
import Icon from '../../../../core/Icon';
import DropdownButton from '../../../../core/DropdownButton';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/core/styles';
import ToggleIcon from './ToggleIcon';
var useStyles = makeStyles(function (theme) {
  return {
    divider: {
      height: 24,
      backgroundColor: '#000000',
      margin: theme.spacing(1)
    }
  };
}, {
  name: 'ECEmbedToolbarButtons'
});

var EmbedToolbarButtons = function EmbedToolbarButtons(_ref) {
  var controls = _ref.controls,
      alignRight = _ref.alignRight;
  var classes = useStyles({});
  return React.createElement(Grid, {
    container: true,
    alignItems: "center",
    justify: alignRight ? 'flex-end' : 'center'
  }, controls && controls.map(function (control) {
    var type = control.type,
        iconType = control.iconType,
        rest = _objectWithoutProperties(control, ["type", "iconType"]);

    return React.createElement(React.Fragment, null, control.type === 'dropdown' && React.createElement(DropdownButton, {
      showArrowIcon: true,
      label: control.value,
      icon: control.icon,
      labelPlacement: "end",
      options: control.options,
      disabled: control.disabled,
      collapseIfSingle: true,
      style: control.style
    }), control.type === 'divider' && React.createElement(Divider, {
      orientation: "vertical",
      classes: {
        root: classes.divider
      }
    }), control.type === 'icon' && React.createElement(Icon, Object.assign({
      key: control.type || control.className
    }, rest, {
      type: iconType
    })), control.type === 'toggleIcon' && React.createElement(ToggleIcon, Object.assign({
      key: control.type || control.className
    }, rest)), control.type === 'moreOptions' && React.createElement(DropdownButton, {
      options: control.options,
      type: "more",
      hoverable: true
    }));
  }));
};

export default EmbedToolbarButtons;